import { ContextProvider } from '@lit/context';
class LazyProviderError extends Error {
    constructor(host, context) {
        super(`Context provider is not available for ${host.tagName} ${context.toString()}`);
    }
}
export class LazyProvider {
    get value() {
        if (this.provider.value === undefined) {
            throw new LazyProviderError(this.host, this.options.context);
        }
        return this.provider.value;
    }
    get isInit() {
        return this.provider.value !== undefined;
    }
    constructor(host, options) {
        this.host = host;
        this.options = options;
        this.provider = new ContextProvider(host, options);
    }
    set(value) {
        this.provider.setValue(value);
    }
}
export const lazyProvider = (host, options) => new LazyProvider(host, options);
//# sourceMappingURL=lazy-provider.js.map